// src/utils/baseUrl.ts

export const getBaseUrl = () => {
  const permissions = localStorage.getItem('permissions');

  return `api/${permissions === 'BUYER' ? 'buyer' : permissions === 'SELLER' ? 'seller' : 'admin'}`;
};
export const getAdminMemberBaseUrl = () => {
  const permissions = localStorage.getItem('permissions');

  return `api/${permissions === 'ADMIN' ? 'admin' : 'member'}`;
};
